import { shallowMount } from '@vue/test-utils';

import Component from './CollectSignatureModal.vue';

let wrapper;

describe('CollectSignatureModal', () => {
  beforeEach(() => {
    wrapper = shallowMount(Component);
  });

  test('render', () => {
    expect(wrapper.isVisible()).toBe(true);
  });
});
